import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const AddonEditLazy = loadable(() => import(/* webpackChunkName: "Addons" */ './AddonEditSuspense'));

export const AddonEditAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <AddonEditLazy />
    </DelayedSuspense>
);
